import axios from "axios";

const restServiceGet = (apiToken, path, options = {}) => {
  return axios.get(process.env.REACT_APP_API_BASE_URL + path, {
    ...options,
    headers: { Authorization: apiToken, ...(options.headers || {}) },
  });
};

const restServicePost = (apiToken, path, data, options = {}) => {
  return axios.post(process.env.REACT_APP_API_BASE_URL + path, data, {
    ...options,
    headers: { Authorization: apiToken, ...(options.headers || {}) },
  });
};

const restServicePut = (apiToken, path, data, options = {}) => {
  return axios.put(process.env.REACT_APP_API_BASE_URL + path, data, {
    ...options,
    headers: { Authorization: apiToken, ...(options.headers || {}) },
  });
};

const restServiceDelete = (apiToken, path, options = {}) => {
  return axios.delete(process.env.REACT_APP_API_BASE_URL + path, {
    ...options,
    headers: { Authorization: apiToken, ...(options.headers || {}) },
  });
};

export { restServiceGet, restServicePost, restServicePut, restServiceDelete };
